import classnames from "classnames";

export const typesenseClientConfig = {
  query_by: "*",
}

export const Config = {
  Defaults: {
    TimeIntervals: 8
  },
  Styles: {
    Chart: {
      DefaultLineStyle: 'linear', // monotone || linear
      Axis: {
        Tick: {fill: '#000000', fontSize: 13},
        AxisLine: {stroke: '#000000', width: 2}
      },
      Width: '100%',
      Height: 600,
    },
  },
  I18n: {
    Filters: {
      Title: 'Filters'
    },
    Timeline: {
      DefaultValue: 'All'
    }
  }
};

export const futureFlags = () => {
  return {
    preserveSharedStateOnUnmount: true,
  };
};

export const filtersConfig = (config) => {
  const {
    filterBy = ''
  } = config;

  if (filterBy && filterBy.trim().length > 0) {
    return `${filterBy.trim()}`
  }

  return null;
};

export function chartStyles(style) {
  return {
    root: classnames({
      'nv-chart': true,
      [`nv-chart--style-${style}`]: true
    })
  };
}

export function templateReplace(str, data) {
  return str.replace(/{{\s*([^}]+)\s*}}/g, (_, key) => {
    return data[key] !== undefined ? data[key] : '';
  });
}

export function buildData(items, config) {
  const groupByFields = config.groupByFields.split(',').map(f => f.trim());
  const groupLabelFormat = config.groupLabelFormat;
  const xField = config.axes.x.field;
  const yField = config.axes.y.field;

  if (!items.length) return { data: [], groups: [] };

  items = items.map(item => {
    item[xField] = Math.round(item[xField]);
    item[yField] = Math.round(item[yField]);
    return item;
  });

  const groupsMap = new Map();
  items.forEach(item => {
    const key = groupByFields.map(f => item[f]).join('|');
    if (!groupsMap.has(key)) {
      groupsMap.set(key, []);
    }
    groupsMap.get(key).push(item);
  });

  const xValues = Array.from(new Set(items.map(i => i[xField]))).sort((a, b) => a - b);

  const data = xValues.map(xVal => {
    const obj = { [xField]: xVal };
    groupsMap.forEach((grpItems, key) => {
      const item = grpItems.find(i => i[xField] === xVal);
      obj[key] = item ? item[yField] : null;
      if (item) {
        obj[`${key}__entry`] = item;
      }
    });
    return obj;
  });

  const groups = Array.from(groupsMap.keys()).map(key => {
    const fields = key.split('|');
    let label = key;
    if (groupLabelFormat) {
      label = groupLabelFormat;
      groupByFields.forEach((f, idx) => {
        const value = fields[idx];
        label = label.replace(`{{${f}}}`, value);
      });
    }

    return {
      id: key,
      label,
      fields,
      items: groupsMap.get(key),
    };
  });
  return { data, groups };
}

export function IsRefinableItem(list, item){
  return item.count > 0 && list.includes(item.value);
}
